import * as React from 'react';
import Box from '@mui/material/Box';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


function SwipeableTextMobileStepper(imgContainer) {
    const [, setActiveStep] = React.useState(0);
    const images = imgContainer.imgContainer;

    const handleSlideChange = (swiper) => {
        setActiveStep(swiper.activeIndex);
    };

    return (
        <Box sx={{ border: 1 }}>
            <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                }}
                navigation={false}
                pagination={{ clickable: true }}
                onSlideChange={handleSlideChange}
                style={{ width: '100%' }}
            >
                {images.map((step, index) => (
                    <SwiperSlide key={step.label}>
                        <Box
                            component="img"
                            sx={{
                                display: 'block',
                                overflow: 'hidden',
                                width: '100%',
                                height: 'auto',
                            }}
                            src={step.imgPath}
                            alt={step.label}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
}

export default SwipeableTextMobileStepper;
